import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { breakpoints } from '@chegg-ui/theme';
export var ScreenSize = /*#__PURE__*/function (ScreenSize) {
  ScreenSize["DESKTOP"] = "DESKTOP";
  ScreenSize["LAPTOP"] = "LAPTOP";
  ScreenSize["TABLET"] = "TABLET";
  ScreenSize["PHONE"] = "PHONE";
  return ScreenSize;
}({});
export var screenSizeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ScreenSize.DESKTOP, Number.parseInt(breakpoints.xl.min)), ScreenSize.LAPTOP, Number.parseInt(breakpoints.lg.min)), ScreenSize.TABLET, Number.parseInt(breakpoints.md.min)), ScreenSize.PHONE, Number.parseInt(breakpoints.sm.min));